import { useState } from "react"
import { Modal, ModalBody } from "reactstrap"
import { FaBoxOpen, FaCheck } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import "./ItemPickerModal.css"

const ItemPickerModal = ({ isOpen, toggle, allItems, onSelect, currentValue }) => {
  const { t } = useTranslation()
  const [search, setSearch] = useState("")
  const [hoveredId, setHoveredId] = useState(null)

  const filtered = allItems.filter(
    (item) =>
      item.status === "Active" &&
      item.item_name.toLowerCase().includes(search.toLowerCase())
  )

  const handleSelect = (item) => {
    onSelect({
      category: item.category,
      value: item._id,
      label: item.item_name,
      ItemGroup: item.ItemGroup,
      item_code: item.item_code,
      price: item.price,
      BaseUOM: item.BaseUOM,
      Images: item.Images,
    })
    toggle()
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" className="item-picker-modal" centered>
      <ModalBody className="p-0">
        {/* Header */}
        <div className="ipm-header">
          <div className="d-flex align-items-center gap-3">
            <div className="ipm-header-icon">
              <FaBoxOpen size={20} />
            </div>
            <div>
              <h5 className="mb-0 fw-bold">{t("Browse Items")}</h5>
              <small className="text-muted">{filtered.length} {t("items available")}</small>
            </div>
          </div>
          <button type="button" className="btn-close" onClick={toggle} aria-label="Close" />
        </div>

        {/* Search */}
        <div className="ipm-search-bar">
          <i className="fas fa-search ipm-search-icon" />
          <input
            className="ipm-search-input"
            placeholder={t("Search by item name\u2026")}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
          {search && (
            <button className="ipm-search-clear" onClick={() => setSearch("")}>
              &times;
            </button>
          )}
        </div>

        {/* Grid */}
        <div className="ipm-grid-container">
          {filtered.length === 0 ? (
            <div className="ipm-empty">
              <i className="fas fa-search fa-3x mb-3 text-muted" />
              <p className="text-muted mb-0">{t("No items match your search.")}</p>
            </div>
          ) : (
            <div className="ipm-grid">
              {filtered.map((item) => {
                const isSelected = currentValue?.value === item._id
                const thumbnail = item.Images?.[0] || null
                return (
                  <div
                    key={item._id}
                    className={`ipm-card ${isSelected ? "ipm-card--selected" : ""} ${hoveredId === item._id ? "ipm-card--hover" : ""}`}
                    onClick={() => handleSelect(item)}
                    onMouseEnter={() => setHoveredId(item._id)}
                    onMouseLeave={() => setHoveredId(null)}
                  >
                    <div className="ipm-card-image">
                      {thumbnail ? (
                        <img src={thumbnail} alt={item.item_name} className="ipm-img" />
                      ) : (
                        <div className="ipm-no-img">
                          <i className="fas fa-pills" />
                        </div>
                      )}
                      {isSelected && (
                        <div className="ipm-selected-badge">
                          <FaCheck size={12} />
                        </div>
                      )}
                    </div>
                    <div className="ipm-card-body">
                      <p className="ipm-item-name">{item.item_name}</p>
                      <div className="ipm-meta">
                        {item.item_code && <span className="ipm-chip">{item.item_code}</span>}
                        {item.BaseUOM && <span className="ipm-chip ipm-chip--uom">{item.BaseUOM}</span>}
                      </div>
                      {item.price > 0 && (
                        <p className="ipm-price">RM {Number(item.price).toFixed(2)}</p>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ItemPickerModal
